// extracted by mini-css-extract-plugin
export default {"buttonContainer":"CompareButton_buttonContainer__lNQyF","button":"CompareButton_button__YRX+k"};